export enum ActionName {
    EditWorkOrder = "mnueditworkorder",
    EditItem = "mnuedititem",
    EditCategory = "mnueditcategory",
    AddProducts = "btnaddproducts",
    NewWorkOrder = "btnnewworkorder",
    ReviewWorkOrder = "mnureviewworkorders",
    WorkOrderDispatcher = "mnudispatching",
    EditWorkOrderDispatcher = "mnueditdispatching",
    AddDiscount = "btnadddiscount",
    DeletePaymentTerm = "btndeletepaymentterm",
    DeleteCompanyCodes = "btndeletecompanycodes",
    EditCompanyCodes = "btneditcompanycodes",
    EditCustomer = "mnueditcustomer",
    ManageWorkOrders = "mnumanageworkorders",
    DeleteTaxMaintenance = "btndeletetaxmaintenance",
    EditDiscount = "btneditdiscount",
    DeletePromisedTime = "btndeletepromisedtime",
    CompanyCodes = "btncompanycodes",
    AddCompanyCodes = "btnaddcompanycodes",
    DeleteDiscount = "btndeletediscount",
    PromisedTime = "btnpromisedtime",
    Categories = "mnucategories",
    AddPaymentTerm = "btnaddpaymentterm",
    TaxMaintenance = "btntaxmaintenance",
    Discount = "btndiscount",
    AddTaxMaintenance = "btnaddtaxmaintenance",
    EditWorkOrderReview = "mnueditworkorderreview",
    EditTaxMaintenance = "btnedittaxmaintenance",
    AddPromisedTime = "btnaddpromisedtime",
    CreateCustomer = "btncreatecustomer",
    EditPaymentTerm = "btneditpaymentterm",
    ManageProducts = "mnumanageproducts",
    EditPromisedTime = "btneditpromisedtime",
    PaymentTerms = "btnpaymentterms",
    AccountingCodes="btnaccountingcodes",
    PaymentMethods="btnpaymentmethods",
    AddAccountingCodes = "btnaddaccountingcode",
    DeleteAccountingCodes = "btndeleteaccountingcodes",
    EditAccountingCodes = "btneditaccountingcodes",
    EditPaymentMethods = "btneditpaymentmethods",
    Customers = "mnucustomers",
    AccountingLog = "mnuaccountinglog",
    Dashboard = "mnudashboard",
    ImportData = "mnuimportdata",
    WorkOrderReport = "mnuworkorderreport",
    EquipmentReport = "mnujobsiteequipmentreport",
    ServiceAgreementReport = "mnuserviceagreementreport",
    AddJobsiteEquipment = "btncreatecustomer",
    EditJobsiteEquipment = "mnueditcustomer",
    DeleteJobsiteEquipment = "mnueditcustomer",
    EquipmentWarranty = "btnequipmentwarranty",
    AddEquipWarranty = "btnaddequipmentwarranty",
    EditEquipWarranty = "btneditequipmentwarranty",
    DeleteEquipWarranty = "btndeleteequipmentwarranty",
    Company = "btncompany",
    EditCompany = "btneditcompany",
    ServiceAgreement = "mnuserviceagreement",
    AddServiceAgreement = "btnaddserviceagreement",
    EditServiceAgreement = "btneditserviceagreement",
    ViewServiceAgreement = "btnserviceagreement",
    AddEstimate = "btnNewEstimate",
    EditEstimate = "mnuEditEstimate",
    Estimate = "mnuManageEstimate",
}